import {useEffect} from "react";
import {Navigate} from "react-router-dom";
import {App} from "antd";

import {useAuth} from "@modules/auth/AuthContext.jsx";
import {ROUTE_MAP} from "@modules/auth/menuCatalog.js";

// Guardia di rotta: regola UNICA → se manca la voce, redirect alla landing + toast.
export default function RequireMenu({menuKey, children})
{
	const {hasMenu, landingMenuItem} = useAuth();
	const {message} = App.useApp();
	const allowed = hasMenu(menuKey);

	useEffect(() =>
	{
		if (!allowed)
			message.warning("Non hai accesso a questa sezione");
	}, [allowed, message]);

	if (allowed)
		return children;

	return <Navigate to={ROUTE_MAP[landingMenuItem] || "/"} replace/>;
}
